import { toast } from 'react-toastify'

import { getAPIClient } from 'api/axios'

export const DELETE_DOCUMENT_SUCCESS = 'Arquivo excluído com sucesso.'
export const DELETE_DOCUMENT_ERROR =
  'Não foi possível excluir o arquivo. Tente novamente.'

/**
 * Exclui um anexo e avisa o resultado.
 *
 * A exclusão vale na hora, sem passar pelo Salvar do formulário, e não tem desfazer —
 * por isso quem chama confirma antes, e por isso o sucesso também é avisado: sem isso o
 * arquivo apenas sumia da lista e não dava para saber se já tinha saído do servidor.
 *
 * Devolve `true` só quando o servidor confirmou, para quem chama decidir se tira o item
 * da tela. Antes a falha era silenciosa: um 404/500 virava sucesso visual e o arquivo
 * reaparecia no reload seguinte.
 */
export async function deleteDocumentFile(path: string): Promise<boolean> {
  try {
    await getAPIClient().delete(path)
    toast.success(DELETE_DOCUMENT_SUCCESS)
    return true
  } catch (err: any) {
    toast.error(err?.response?.data?.message || DELETE_DOCUMENT_ERROR)
    return false
  }
}
